const OFFLINE_CONTENT_PREFIX = 'lcdf_offline_content:';

const isBrowser = typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';

const getStorageKey = (key) => `${OFFLINE_CONTENT_PREFIX}${key}`;

const isValidValue = (value) => value !== null && value !== undefined && value !== '';

export const saveOfflineContent = (key, value) => {
  if (!isBrowser || !isValidValue(value)) {
    return;
  }

  window.localStorage.setItem(
    getStorageKey(key),
    JSON.stringify({
      value,
      updatedAt: new Date().toISOString(),
    })
  );
};

export const getOfflineContent = (key) => {
  if (!isBrowser) {
    return null;
  }

  const rawValue = window.localStorage.getItem(getStorageKey(key));

  if (!rawValue) {
    return null;
  }

  try {
    return JSON.parse(rawValue);
  } catch (_error) {
    return null;
  }
};
